import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export class AppointmentHelper {
    static calculateAppointmentDuration(startDate, endDate) {
        const startTime = dayjs.utc(startDate);
        const endTime = dayjs.utc(endDate);
        const durationMinutes = endTime.diff(startTime, 'minute');
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;
        if (hours > 0 && minutes > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes > 1 ? 's' : ''}`;
        }
        if (hours > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''}`;
        }
        return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    }
}
